const en = {
  eyebrow: 'FAQ',
  title: 'Frequently Asked Questions',
  description:
    'Everything about our flowers, balloons, timelines and setup. Don’t see your question? Message us on WhatsApp — we reply in about 15 minutes.',
  searchPlaceholder: 'Search questions…',
  searchLabel: 'Search frequently asked questions',
  noResults: 'No questions match that search.',
  clearSearch: 'Clear search',
  stillHelp: 'Still have a question?',
  stillHelpCta: 'Ask us on WhatsApp',
  items: [
    {
      q: 'What is your delivery area?',
      a: 'We serve Jessup, Maryland and surrounding areas within a 15-mile radius. For events outside this area, please contact us for special arrangements.',
    },
    {
      q: 'How far in advance should I book?',
      a: 'Most clients book three to eight weeks ahead. Rush orders are possible when flowers are in season. For balloons, we can often accommodate shorter timelines.',
    },
    {
      q: 'Can you combine flowers and balloons in one event?',
      a: 'Absolutely! Many of our most stunning events combine floral elegance with balloon artistry. It creates a unique, memorable look.',
    },
    {
      q: 'How long do balloon decorations last?',
      a: 'Latex balloons last 5–7 days indoors. Foil/mylar balloons last 2–4 weeks. Balloon structures are set up the day before or the day of your event.',
    },
    {
      q: 'Can you do custom or themed balloon designs?',
      a: 'Yes! We create themed balloon setups for birthdays, baby showers, character themes and more. See our portfolio for examples.',
    },
    {
      q: 'Do you offer wedding or event packages?',
      a: 'We customize pricing based on your specific needs. Floral packages start at $450, balloon installations from $75. Call for details.',
    },
    {
      q: 'What if I need last-minute arrangements?',
      a: 'Same-day service is possible! Flowers depend on seasonal availability. Balloons can often be arranged on short notice. Call immediately.',
    },
    {
      q: 'How do you ensure flower freshness?',
      a: 'We source flowers fresh the week of your event and use professional techniques to keep them beautiful throughout your celebration.',
    },
  ],
}

const es: typeof en = {
  eyebrow: 'Preguntas',
  title: 'Preguntas Frecuentes',
  description:
    'Todo sobre nuestras flores, globos, tiempos e instalación. ¿No ve su pregunta? Escríbanos por WhatsApp — respondemos en unos 15 minutos.',
  searchPlaceholder: 'Buscar preguntas…',
  searchLabel: 'Buscar en las preguntas frecuentes',
  noResults: 'Ninguna pregunta coincide con esa búsqueda.',
  clearSearch: 'Borrar búsqueda',
  stillHelp: '¿Todavía tiene una pregunta?',
  stillHelpCta: 'Pregúntenos por WhatsApp',
  items: [
    {
      q: '¿Cuál es su área de entrega?',
      a: 'Servimos a Jessup, Maryland y áreas cercanas dentro de un radio de 15 millas. Para eventos fuera de esta área, contáctenos para hacer arreglos especiales.',
    },
    {
      q: '¿Con cuánta anticipación debo reservar?',
      a: 'La mayoría de los clientes reservan de tres a ocho semanas antes. Los pedidos urgentes son posibles cuando hay flores en temporada. Para globos, a menudo podemos trabajar con plazos más cortos.',
    },
    {
      q: '¿Pueden combinar flores y globos en un mismo evento?',
      a: '¡Por supuesto! Muchos de nuestros eventos más impresionantes combinan la elegancia floral con el arte de los globos. Crea un estilo único y memorable.',
    },
    {
      q: '¿Cuánto duran las decoraciones de globos?',
      a: 'Los globos de látex duran de 5 a 7 días en interiores. Los globos metálicos duran de 2 a 4 semanas. Las estructuras se instalan el día anterior o el mismo día del evento.',
    },
    {
      q: '¿Hacen diseños de globos personalizados o temáticos?',
      a: '¡Sí! Creamos montajes temáticos para cumpleaños, baby showers, temas de personajes y más. Vea nuestro portafolio para ejemplos.',
    },
    {
      q: '¿Ofrecen paquetes para bodas o eventos?',
      a: 'Personalizamos el precio según sus necesidades. Los paquetes florales comienzan en $450 y las instalaciones de globos desde $75. Llame para más detalles.',
    },
    {
      q: '¿Qué pasa si necesito arreglos de último momento?',
      a: '¡El servicio el mismo día es posible! Las flores dependen de la temporada. Los globos a menudo se pueden preparar con poco aviso. Llame de inmediato.',
    },
    {
      q: '¿Cómo garantizan la frescura de las flores?',
      a: 'Conseguimos las flores frescas la semana de su evento y usamos técnicas profesionales para mantenerlas hermosas durante toda su celebración.',
    },
  ],
}

export const faq = { en, es }
